// extracted by mini-css-extract-plugin
export default {"root":"LayoutCustomisation-root-RxK","login":"LayoutCustomisation-login-eHs","side":"LayoutCustomisation-side-QCP","main":"LayoutCustomisation-main-vvq"};